"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Plan_997 = exports.Plan_990 = exports.Plan_989 = exports.Plan_988 = exports.Plan_987 = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Plan_987 = exports.Plan_987 = {
  planNumber: 987,
  kindOfCover: "70%",
  externalName: "Pet Protect",
  coolingOffPeriod: true,
  gapOnly: true,
  dental: false,
  routineCare: false,
  emergencyBoarding: true,
  emergencyBoardingFees: "$10,000",
  petSpecies: ["CANINE", "FELINE"],
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 70,
    "excessCode": "3978",
    "excessNo": 3978
  }, {
    "excess": 100,
    "levelOfCover": 70,
    "excessCode": "3979",
    "excessNo": 3979
  }, {
    "excess": 250,
    "levelOfCover": 70,
    "excessCode": "3980",
    "excessNo": 3980
  }, {
    "excess": 200,
    "levelOfCover": 70,
    "excessCode": "3981",
    "excessNo": 3981
  }, {
    "excess": 500,
    "levelOfCover": 70,
    "excessCode": "3982",
    "excessNo": 3982
  }],
  levelsOfCover: [70],
  staffOnly: false,
  staffLevelsOfCover: [],
  stepDownLevelsOfCover: [],
  stepDown: false,
  staffOnlyExcesses: [200, 500],
  limits: {
    "ageLimits": {
      "minAgeDays": 55,
      "maxAgeDays": 3287,
      "displayValue": "Older than 8 weeks and younger than 9 years"
    },
    "annualLimit": {
      "amount": 10000,
      "formattedAmount": "$10,000",
      "displayValue": "$10,000"
    },
    "consultationLimit": "$400 sub-limit",
    "consultationsAndVet": "$400 sub-limit",
    "consultationsAndVisits": "$400 sub-limit",
    "consultation": true,
    "cruciateLigament": "$4,000 sub-limit per leg",
    "cruciateLigamentLimit": "$4,000 sub-limit",
    "cruciateLigamentLeftLeg": "$4,000 sub-limit",
    "cruciateLigamentRightLeg": "$4,000 sub-limit",
    "paralysisTick": "$4,000 sub-limit",
    "tickParalysis": "$4,000 sub-limit",
    "hipJointLeftHip": "$4,000 sub-limit per hip",
    "hipJointRightHip": "$4,000 sub-limit per hip",
    "emergencyBoardingFees": "$10,000"
  },
  waitingPeriods: {
    "detailed": {
      "waitingPeriodMessages": ["No waiting period for specified accidental injuries.", "No waiting period for emergency boarding."],
      "waitingPeriod": "No waiting period for specified accidental injuries.<br/>No waiting period for emergency boarding.",
      "itemisedWaitingPeriods": {
        "specifiedAccidentalInjuries": {
          "waitTime": "No waiting period",
          "label": "specified accidental injuries"
        },
        "emergencyBoarding": {
          "waitTime": "No waiting period",
          "label": "emergency boarding"
        }
      }
    }
  },
  customCoverDetails: {
    "afterLifeCare": false,
    "alprazolam": false,
    "amitriptyline": false,
    "behaviouralAssessment": false,
    "behaviouralTherapy": false,
    "councilRegistration": false,
    "desexing": false,
    "essentialEuthanasia": false,
    "fleaControlDrugs": false,
    "fleaTickControlDrugs": false,
    "fleaWormDrugs": false,
    "heartWormDrugs": false,
    "intestinalWormDrugs": false,
    "jointSupplements": false,
    "microchipping": false,
    "oralRinseDrugs": false,
    "prescriptionDiet": false,
    "routineTeethCleaning": false,
    "teethCleaningProducts": false,
    "vaccinationCat": false,
    "vaccinationDog": false,
    "coversIllness": true,
    "infectiousDisease": true,
    "toxicityPoisoning": true,
    "trichobezoar": true,
    "ingestionOfForeignBodies": true,
    "ingestionToxicity": true
  },
  isBasePlan: true,
  addOns: []
};
var Plan_988 = exports.Plan_988 = _objectSpread(_objectSpread({}, Plan_987), {}, {
  planNumber: 988,
  kindOfCover: "70% + New RC",
  externalName: "Pet Protect with Routine Care",
  routineCare: true,
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 70,
    "excessCode": "3983",
    "excessNo": 3983
  }, {
    "excess": 100,
    "levelOfCover": 70,
    "excessCode": "3984",
    "excessNo": 3984
  }, {
    "excess": 250,
    "levelOfCover": 70,
    "excessCode": "3985",
    "excessNo": 3985
  }, {
    "excess": 200,
    "levelOfCover": 70,
    "excessCode": "3986",
    "excessNo": 3986
  }, {
    "excess": 500,
    "levelOfCover": 70,
    "excessCode": "3987",
    "excessNo": 3987
  }],
  limits: _objectSpread(_objectSpread({}, Plan_987.limits), {}, {
    dentalCareLimit: undefined,
    dentalLimitBreakDown: undefined,
    emergencyBoardingLimit: undefined,
    routineCareLimit: "$165",
    routineCareLimitBreakDown: [{
      "description": "HEARTWORM TEST OR BLOOD SCREEN",
      "code": "DG02934",
      "limit": 10
    }, {
      "description": "FLEA/TICK/WORM CONTROL",
      "code": "DG02937",
      "limit": 45
    }, {
      "description": "DESEXING",
      "code": "DG02938",
      "limit": 50
    }, {
      "description": "HEARTWORM PREVENTATIVE MEDICATION",
      "code": "DG02939",
      "limit": 50
    }, {
      "description": "DEWCLAW REMOVAL",
      "code": "DG02940",
      "limit": 50
    }, {
      "description": "PRESCRIPTION DIETS",
      "code": "DG02941",
      "limit": 50
    }, {
      "description": "CREMATION/BURIAL",
      "code": "DG02942",
      "limit": 50
    }, {
      "description": "MICROCHIPPING",
      "code": "DG02943",
      "limit": 50
    }, {
      "description": "TEETH CLEANING",
      "code": "DG02944",
      "limit": 50
    }, {
      "description": "COUNCIL REGISTRATION FEES",
      "code": "DG02945",
      "limit": 50
    }, {
      "description": "ALTERNATIVE THERAPIES",
      "code": "DG02946",
      "limit": 50
    }, {
      "description": "OBEDIENCE TRAINING",
      "code": "DG02948",
      "limit": 50
    }, {
      "description": "VACCINATIONS OR HEALTH CHECKS",
      "code": "DG02932",
      "limit": 50
    }, {
      "description": "FELV/FIV TEST OR URINALYSIS",
      "code": "FFT_OR_URI",
      "limit": 10
    }, {
      "description": "Routine Group",
      "code": "RGMEDBANK2",
      "limit": 100
    }],
    alternativeCareLimit: undefined,
    alternativeCareLimitBreakdown: undefined
  }),
  waitingPeriods: _objectSpread(_objectSpread({}, Plan_987.waitingPeriods), {}, {
    detailed: _objectSpread(_objectSpread({}, Plan_987.waitingPeriods.detailed), {}, {
      waitingPeriodMessages: ["30 days for general veterinary expenses.", "No waiting period for specified accidental injuries.", "No waiting period for emergency boarding.", "No waiting period for routine care where selected."],
      waitingPeriod: "30 days for general veterinary expenses.<br/>No waiting period for specified accidental injuries.<br/>No waiting period for emergency boarding.<br/>No waiting period for routine care where selected.",
      itemisedWaitingPeriods: _objectSpread(_objectSpread({}, Plan_987.waitingPeriods.detailed.itemisedWaitingPeriods), {}, {
        generalVeterinaryExpenses: {
          "waitTime": "30 days",
          "label": "general veterinary expenses"
        },
        routineCare: {
          "waitTime": "No waiting period",
          "label": "routine care where selected"
        }
      })
    })
  }),
  isVariant: true,
  basePlanNo: 987,
  addOns: ["routineCare"],
  isBasePlan: false
});
var Plan_989 = exports.Plan_989 = _objectSpread(_objectSpread({}, Plan_987), {}, {
  planNumber: 989,
  kindOfCover: "70% + Dental/Alt/Behavioural",
  externalName: "Pet Protect with Extra Care",
  dental: true,
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 70,
    "excessCode": "3988",
    "excessNo": 3988
  }, {
    "excess": 100,
    "levelOfCover": 70,
    "excessCode": "3989",
    "excessNo": 3989
  }, {
    "excess": 250,
    "levelOfCover": 70,
    "excessCode": "3990",
    "excessNo": 3990
  }, {
    "excess": 200,
    "levelOfCover": 70,
    "excessCode": "3991",
    "excessNo": 3991
  }, {
    "excess": 500,
    "levelOfCover": 70,
    "excessCode": "3992",
    "excessNo": 3992
  }],
  limits: _objectSpread(_objectSpread({}, Plan_987.limits), {}, {
    dentalCareLimit: "$2,000",
    dentalLimitBreakDown: undefined,
    emergencyBoardingLimit: undefined,
    routineCareLimit: undefined,
    routineCareLimitBreakDown: undefined,
    alternativeCareLimit: "$2,000",
    alternativeCareLimitBreakdown: undefined
  }),
  waitingPeriods: _objectSpread(_objectSpread({}, Plan_987.waitingPeriods), {}, {
    detailed: _objectSpread(_objectSpread({}, Plan_987.waitingPeriods.detailed), {}, {
      waitingPeriodMessages: ["30 days for general veterinary expenses.", "No waiting period for specified accidental injuries.", "No waiting period for emergency boarding.", "30 days for alternative care.", "6 months for dental illness treatments where selected."],
      waitingPeriod: "30 days for general veterinary expenses.<br/>No waiting period for specified accidental injuries.<br/>No waiting period for emergency boarding.<br/>30 days for alternative care.<br/>6 months for dental illness treatments where selected.",
      itemisedWaitingPeriods: _objectSpread(_objectSpread({}, Plan_987.waitingPeriods.detailed.itemisedWaitingPeriods), {}, {
        generalVeterinaryExpenses: {
          "waitTime": "30 days",
          "label": "general veterinary expenses"
        },
        alternativeCare: {
          "waitTime": "30 days",
          "label": "alternative care"
        },
        dental: {
          "waitTime": "6 months",
          "label": "dental illness treatments where selected"
        }
      })
    })
  }),
  isVariant: true,
  basePlanNo: 987,
  addOns: ["dental", "alternativeCare"],
  isBasePlan: false
});
var Plan_990 = exports.Plan_990 = _objectSpread(_objectSpread({}, Plan_987), {}, {
  planNumber: 990,
  kindOfCover: "70% + Dental/Alt/Behavioural + New RC",
  externalName: "Pet Protect with Extra Care and Routine Care",
  dental: true,
  routineCare: true,
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 70,
    "excessCode": "3993",
    "excessNo": 3993
  }, {
    "excess": 100,
    "levelOfCover": 70,
    "excessCode": "3994",
    "excessNo": 3994
  }, {
    "excess": 250,
    "levelOfCover": 70,
    "excessCode": "3995",
    "excessNo": 3995
  }, {
    "excess": 200,
    "levelOfCover": 70,
    "excessCode": "3996",
    "excessNo": 3996
  }, {
    "excess": 500,
    "levelOfCover": 70,
    "excessCode": "3997",
    "excessNo": 3997
  }],
  limits: _objectSpread(_objectSpread({}, Plan_987.limits), {}, {
    dentalCareLimit: "$2,000",
    dentalLimitBreakDown: undefined,
    emergencyBoardingLimit: undefined,
    routineCareLimit: "$165",
    routineCareLimitBreakDown: [{
      "description": "HEARTWORM TEST OR BLOOD SCREEN",
      "code": "DG02934",
      "limit": 10
    }, {
      "description": "FLEA/TICK/WORM CONTROL",
      "code": "DG02937",
      "limit": 45
    }, {
      "description": "DESEXING",
      "code": "DG02938",
      "limit": 50
    }, {
      "description": "HEARTWORM PREVENTATIVE MEDICATION",
      "code": "DG02939",
      "limit": 50
    }, {
      "description": "DEWCLAW REMOVAL",
      "code": "DG02940",
      "limit": 50
    }, {
      "description": "PRESCRIPTION DIETS",
      "code": "DG02941",
      "limit": 50
    }, {
      "description": "CREMATION/BURIAL",
      "code": "DG02942",
      "limit": 50
    }, {
      "description": "MICROCHIPPING",
      "code": "DG02943",
      "limit": 50
    }, {
      "description": "TEETH CLEANING",
      "code": "DG02944",
      "limit": 50
    }, {
      "description": "COUNCIL REGISTRATION FEES",
      "code": "DG02945",
      "limit": 50
    }, {
      "description": "ALTERNATIVE THERAPIES",
      "code": "DG02946",
      "limit": 50
    }, {
      "description": "OBEDIENCE TRAINING",
      "code": "DG02948",
      "limit": 50
    }, {
      "description": "VACCINATIONS OR HEALTH CHECKS",
      "code": "DG02932",
      "limit": 50
    }, {
      "description": "FELV/FIV TEST OR URINALYSIS",
      "code": "FFT_OR_URI",
      "limit": 10
    }, {
      "description": "Routine Group",
      "code": "RGMEDBANK2",
      "limit": 100
    }],
    alternativeCareLimit: "$2,000",
    alternativeCareLimitBreakdown: undefined
  }),
  waitingPeriods: _objectSpread(_objectSpread({}, Plan_987.waitingPeriods), {}, {
    detailed: _objectSpread(_objectSpread({}, Plan_987.waitingPeriods.detailed), {}, {
      waitingPeriodMessages: ["30 days for general veterinary expenses.", "No waiting period for specified accidental injuries.", "No waiting period for emergency boarding.", "30 days for alternative care.", "No waiting period for routine care where selected.", "6 months for dental illness treatments where selected."],
      waitingPeriod: "30 days for general veterinary expenses.<br/>No waiting period for specified accidental injuries.<br/>No waiting period for emergency boarding.<br/>30 days for alternative care.<br/>No waiting period for routine care where selected.<br/>6 months for dental illness treatments where selected.",
      itemisedWaitingPeriods: _objectSpread(_objectSpread({}, Plan_987.waitingPeriods.detailed.itemisedWaitingPeriods), {}, {
        generalVeterinaryExpenses: {
          "waitTime": "30 days",
          "label": "general veterinary expenses"
        },
        alternativeCare: {
          "waitTime": "30 days",
          "label": "alternative care"
        },
        routineCare: {
          "waitTime": "No waiting period",
          "label": "routine care where selected"
        },
        dental: {
          "waitTime": "6 months",
          "label": "dental illness treatments where selected"
        }
      })
    })
  }),
  isVariant: true,
  basePlanNo: 987,
  addOns: ["dental", "routineCare", "alternativeCare"],
  isBasePlan: false
});
var Plan_997 = exports.Plan_997 = _objectSpread(_objectSpread({}, Plan_987), {}, {
  planNumber: 997,
  kindOfCover: "60%",
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 60,
    "excessCode": "4026",
    "excessNo": 4026
  }, {
    "excess": 100,
    "levelOfCover": 60,
    "excessCode": "4027",
    "excessNo": 4027
  }, {
    "excess": 250,
    "levelOfCover": 60,
    "excessCode": "4028",
    "excessNo": 4028
  }, {
    "excess": 200,
    "levelOfCover": 60,
    "excessCode": "4029",
    "excessNo": 4029
  }, {
    "excess": 500,
    "levelOfCover": 60,
    "excessCode": "4030",
    "excessNo": 4030
  }],
  levelsOfCover: [60],
  staffOnly: true,
  waitingPeriods: _objectSpread(_objectSpread({}, Plan_987.waitingPeriods), {}, {
    detailed: _objectSpread(_objectSpread({}, Plan_987.waitingPeriods.detailed), {}, {
      waitingPeriodMessages: ["30 days for general veterinary expenses.", "No waiting period for specified accidental injuries.", "No waiting period for emergency boarding."],
      waitingPeriod: "30 days for general veterinary expenses.<br/>No waiting period for specified accidental injuries.<br/>No waiting period for emergency boarding.",
      itemisedWaitingPeriods: _objectSpread(_objectSpread({}, Plan_987.waitingPeriods.detailed.itemisedWaitingPeriods), {}, {
        generalVeterinaryExpenses: {
          "waitTime": "30 days",
          "label": "general veterinary expenses"
        }
      })
    })
  }),
  isVariant: true,
  basePlanNo: 987,
  isBasePlan: false
});
var _default = exports["default"] = {
  Plan_987: Plan_987,
  Plan_988: Plan_988,
  Plan_989: Plan_989,
  Plan_990: Plan_990,
  Plan_997: Plan_997
};